<section class="service-banner">
  <div class="container">
    <div class="row">
      <div class="col-xl-11 m-auto">
        <div class="vh-100">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <div class="block-content">
              <div class="d-flex flex-row w-100">
                <h1 class="" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">Your Payment is Successful </h1>
              </div>
              <p>Now Relax, we are creating your dashboard to start the project.</p>
              <p class="md-mb-2 sm-mb-3 mb-3">Please check your email for login details.</p>
              <div class="arrow2">
                <p class="mb-0">
                  <a href="/" class="cstbtn"> <span class="text"> Back to Home</span> <span
                      class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </span> </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>